module.exports = __webpack_public_path__ + "img/report-sample-13@3x.fefad3c1.png";